import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

//scss
import "./Motivator.scss";

const Motivator = () => {
  return (
    <div className="motivator">
      Purchase a new report.
      <Link to="/buy-new-report">Click here</Link>
    </div>
  );
};

Motivator.propTypes = {
  titleKey: PropTypes.string,
};

export default Motivator;
